import { Button } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import { Close } from '../Icons';
import styles from './CloseButton.module.scss';

interface CloseButtonProps {
  onClick: () => unknown;
  className?: string;
}

function CloseButton(props: CloseButtonProps) {
  return (
    <Button
      priority="medium"
      onClick={props.onClick}
      className={classNames(styles.container, props.className)}
    >
      <Close />
    </Button>
  );
}

export default React.memo(CloseButton);
